import constant from "../../constant";
import axios from "axios";
import router from "../../router";
import { printData } from "../../utils/printUtils";
const api = constant.api + "deliveries";
// initial state
const state = () => ({
  all: [],
  deliveries: [],
  
  delivery: {},
});

// getters
const getters = {
  getAll: (state) => state.all,
  
  getDelivery: (state) => state.delivery,
  
  getDeliveries: (state) => {
    return state.deliveries;
  },

};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let deliveries = response.data;
      commit("setDeliveries", deliveries);
    });
  },

  async show({ commit }, reference) {
    await commit("setDelivery", {});
    await this.$api.show(`${api}/${reference}`).then((response) => {
      let delivery = response.data;
      commit("setDelivery", delivery);
    });
    // await axios.get(api + "/" + reference).then((response) => {
    //   let delivery = response.data;
    //   commit("setDelivery", delivery);
    // });
  },

  async store({ commit, dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "deliveries-index" });
      }
    });
  },

  async markAsExit({ commit, dispatch }, reference) {
    await this.$api.create(`${api}_exit/${reference}`).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "deliveries-index" });
      }
    });
  },

  async update({ commit }, data) {
    await this.$api
      .update(api + "/" + data.reference, data)
      .then((response) => {
        let status = response.data.status;

        if (status == "success") {
          router.push({ name: "deliveries-index" });
        }
      });
  },

  async destroy({ commit }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "deliveries-index" });
      }
    });
  },

  async printDeliveryReceipt({ dispatch }, reference) {
    try {
      dispatch(
        "notification/storeDownloading",
        { status: "success", message: "downloading..." },
        { root: true }
      );
      const response = await axios
        .post(api + "_print/" + reference, [], {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "BON-DE-COMMANDE.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },
};

// mutations
const mutations = {
  setDeliveries(state, deliveries) {
    state.all = deliveries;
    state.deliveries = deliveries;
  },
  
  setDelivery(state, delivery) {
    state.delivery = delivery;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
